import React, { useState } from 'react';
import { logError } from '../utilities';
import { ToastContainer, toast } from 'react-toastify';
import { trackShipments } from '../api/trackShipmentApi';
import { TrackShipmentQueryResponse } from '../apiModels/trackShipmentQueryResponse';
import GenericDataTable from './GenericDataTable';
import TrackShipmentResultTableRowFormatter from './TrackShipmentResultTableRowFormatter';
import ContainerPadded from './ContainerPadded';
import ProofOfDeliveryRequestModal from './ProofOfDeliveryRequestModal';

export default function TrackShipmentResultSet(props: {
    submittingForm: boolean,
    shipment: TrackShipmentQueryResponse
}) {
    const [showRequestProofOfDeliveryModal, setShowRequestProofOfDeliveryModal] = useState(false);

    return (
        <div className='col-12'>
            <div className='row mb-3'>
                <h4 className='col-9'>Tracking Number: {props.shipment.trackingNumber}</h4>
                <div className='col-3 text-end'>
                    <button className='btn btn-primary' onClick={() => setShowRequestProofOfDeliveryModal(true)}>Request Proof of Delivery</button>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <GenericDataTable data={props.shipment.updates.sort((x, y) => x.displayOrder - y.displayOrder)}
                        dataFormatter={data => <>{data.map(d => <TrackShipmentResultTableRowFormatter key={d.shipmentStatusId} shipmentUpdate={d} />)}</>}
                        noDataMessage='There are no tracking updates to show at this time.'
                        columnCount={3}
                        isLoading={props.submittingForm}>
                        <tr>
                            <td>Description</td>
                            <td>Location</td>
                            <td>Status</td>
                            <td>Date/Time</td>
                        </tr>
                    </GenericDataTable>
                </div>
            </div>
            <ProofOfDeliveryRequestModal shipmentTrackingNumber={props.shipment.trackingNumber}
                show={showRequestProofOfDeliveryModal}
                setShow={setShowRequestProofOfDeliveryModal} />
        </div>
    );
}
